module.exports = __webpack_public_path__ + "static/media/85.f685c725.png";